// Browser-safe shim for `firebase-admin/firestore` and `@google-cloud/firestore`.
// @dadohr/shared's domainTypes transitively imports these server-only packages
// for the Timestamp class. The FE never writes server-side; it only needs the
// Timestamp type/class for time.ts helpers (Timestamp.now/fromDate/fromMillis,
// new Timestamp(...), refreshTimestamp's instanceof check, toTimestamp ctor).
//
// We redirect those admin imports to the firebase client SDK's Timestamp
// (already a runtime dep of apps), which is API-compatible (same ctor, same
// seconds/nanoseconds, same toDate/toMillis/now/fromDate/fromMillis/isEqual)
// and — crucially — is the same class used by the rest of apps when reading
// from Firestore, so `refreshTimestamp`'s instanceof check passes for client
// data that's already a Timestamp.

import firebase from 'firebase/app';
import 'firebase/firestore';

export const Timestamp = firebase.firestore.Timestamp;
export default { Timestamp };
